import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";

import { LoginContext } from "../../context/login-context";

import Icon from "../icon/icon";
import Menu from "../menu/menu";

import css from "./header.module.css";
import MobTrigger from "./header-trigger";

export const Header = ({
  showUpload,
  toggleShowUpload,
  activePage,
  setActivePage,
}) => {

  const [navOpen, setNavOpen] = useState(false);

	// const canViewReports = userData.user_role == "VALMONT_REP" || userData.user_role == "VALMONT_FINANCE"

  const logo = (
    <NavLink onClick={() => setActivePage("Dashboard")} to="./" className={css.logo}>
      <Icon icon="ValleyLogo" />
    </NavLink>
  );

  const menu = (
    <Menu
      navOpen={navOpen}
      setNavOpen={setNavOpen}
      activePage={activePage}
      setActivePage={setActivePage}
      toggleShowUpload={toggleShowUpload}
    />
  );

	return (
		<header className={css.header}>
			<div className={css.inner}>
				{logo}
        {menu}
			</div>
      <MobTrigger navOpen={navOpen} setNavOpen={setNavOpen} />
		</header>
	);
};
